module.exports = __webpack_public_path__ + "img/39-r.5e8d9d11.png";